import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=767d529a&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('767d529a')) {
      api.createRecord('767d529a', component.options)
    } else {
      api.reload('767d529a', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=767d529a&", function () {
      api.rerender('767d529a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/gobierto_dashboards/webapp/layouts/Main.vue"
export default component.exports